// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12wNa","label":"styles_label__1SmBV"};